import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'src/environments/environment';
import { RapoarteService } from './rapoarte.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { helper } from 'src/environments/helper';
import { Subject } from 'rxjs';
import { MatCalendar } from '@angular/material/datepicker';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
    selector: 'app-rapoarte',
    templateUrl: './rapoarte.component.html',
    styleUrls: ['./rapoarte.component.scss']
})
export class RapoarteComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;

    helper = helper;
    isLoading = false;
    showAll = true;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    // Popover dates

    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    selectedStartDate: Date = new Date(new Date().setDate(new Date().getDate() - 30));
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'last_30_days';

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
        console.log(this.selectedStartDate);
        console.log(this.selectedEndDate);
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    dtLink = environment.interop.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.getRaportDT;

    constructor(
        private http: HttpClient,
        private rapoarteService: RapoarteService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            order: [[0, 'desc']],
            serverSide: true,
            searching: false,
            responsive: true,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.number_of_days = this.getNumberOfDays();
                dataTablesParameters.show_all = this.showAll;
                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id_document',
                },
                {
                    title: 'ID Cetățean',
                    data: null,
                    orderable: false,
                    render: (row: any) => {
                        let cnp_cif;

                        if (row.f_nume === '') {
                            cnp_cif = 'CNP';
                        } else {
                            cnp_cif = 'CIF';
                        }

                        return `
                            <div class="d-flex flex-column">
                                ` + (row.f_nume !== '' ? `<span class="d-flex align-items-center gap-1"><img src="/assets/icons/companii.svg" alt="Image" style="width: 20px; height: 20px;">${row.f_nume}</span>` : '') + `
                                <span class="d-flex align-items-center gap-1"><img src="/assets/icons/icon-user.svg" alt="Image" style="width: 20px; height: 20px;">${row.citizen_name}</span>
                                <span>${cnp_cif}: ${row.cnp_cif}</span>
                                ` + (row.notificare_sms_allow == true ? `<span class="d-flex align-items-center gap-1"><i class="fa-solid fa-phone"></i> ${row.notificare_sms_number}</span>` : '') + `
                                ` + (row.notificare_email_allow == true ? `<span class="d-flex align-items-center gap-1"><i class="fa-regular fa-envelope"></i> ${row.notificare_email_address}</span>` : '') + `
                            </div>
                        `;
                    }
                },
                {
                    title: 'Tip Document',
                    data: 'document_type_name',
                    orderable: false,
                },
                {
                    title: 'Data încărcării',
                    data: 'uploaded_date',
                    render: (data: any) => {
                        return this.formatRomanianDate(data);
                    }
                },
                {
                    title: 'Data arhivării',
                    data: null,
                    render: (row: any) => {
                        if (row.archive_date !== null) {
                            return `<span>${this.formatRomanianDate(row.archive_date)}</span>`;
                        } else {
                            return `<span>N/A</span>`;
                        }
                    }
                },
                {
                    title: 'Data actualizării',
                    data: 'updated_at',
                    render: (data: any) => {
                        return this.formatRomanianDate(data);
                    }
                },
                {
                    title: 'Operator Validare',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (row: any) => {
                        if (row.cancel_date === null) {
                            if (row.validated_date === null) {
                                return `
                                            
                                        `
                            } else {
                                return `
                                            <div class="d-flex flex-column justify-content-left">
                                                <div>
                                                    <div class="d-flex align-items-center">
                                                        <i class="fa-regular fa-user me-2"></i>        
                                                        <span>${row.validated_user_name}</span>
                                                    </div>
                                                    <div class="d-flex align-items-center">
                                                        <i class="fa-regular fa-clock me-2"></i>        
                                                        <span>${this.formatRomanianDate(row.validated_date)}</span>
                                                    </div>
                                                    ` + (row.validated_obs !== null ?
                                        `<div class="d-flex align-items-center">
                                                            <i class="fa-regular fa-comments me-2"></i>       
                                                            <span>${row.validated_obs}</span>
                                                            </div>    
                                                    ` : '') + `
                                                </div>
                                        </div>
                                        `
                            }
                        } else {
                            return `
                                    <div class="d-flex flex-column justify-content-left">
                                        ` + (row.validated_date !== null ? `
                                            <div class="d-flex align-items-center justify-content-start">
                                            <div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-regular fa-user me-2"></i>       
                                                    <span>${row.validated_user_name}</span>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-regular fa-clock me-2"></i>        
                                                    <span>${this.formatRomanianDate(row.validated_date)}</span>
                                                </div>
                                                ` + (row.validated_obs !== null ?
                                        `<div class="d-flex align-items-center">
                                                        <i class="fa-regular fa-comments me-2"></i>       
                                                        <span>${row.validated_obs}</span>
                                                        </div>    
                                                ` : '') + `
                                            </div>
                                        </div>
                                        <hr>
                                            ` : '') + `
                
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-xmark me-2 red-text"></i>          
                                                    <span>${row.cancel_user_name}</span>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-regular fa-clock me-2 red-text"></i>        
                                                    <span>${this.formatRomanianDate(row.cancel_date)}</span>
                                                </div>
                                                ` + (row.cancel_obs !== null ?
                                    `<div class="d-flex align-items-center">
                                                        <i class="fa-regular fa-comments me-2 red-text"></i>       
                                                        <span>${row.cancel_obs}</span>
                                                        </div>    
                                                ` : '') + `
                                            </div>
                                        </div>
                                    </div>
                                `
                        }
                    },
                },
            ]
        };
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
    }

    downloadRaport() {
        return this.rapoarteService.downloadRaport(this.getNumberOfDays(), this.showAll).subscribe({
            next: (response: any) => {
                const url = window.URL.createObjectURL(response);
                window.open(url, '_blank');
                setTimeout(() => window.URL.revokeObjectURL(url), 10000);
            },
            error: (err: any) => {
                console.log(err);
            }
        });
    }

    customRound(days: number): number {
        const fraction = days % 1;
        if (fraction.toString().startsWith('0.999')) {
            return Math.ceil(days);
        } else {
            return Math.floor(days);
        }
    }

    getNumberOfDays() {
        return this.customRound((this.selectedEndDate.getTime() - this.selectedStartDate.getTime()) / (1000 * 60 * 60 * 24));
    }

    onDateFilterChange(): void {
        this.rerenderDT();
    }

    changeShowAll() {
        this.showAll = !this.showAll;
        this.rerenderDT();
    }

    formatRomanianDate(dateTimeString: string): string {
        const [datePart, timePart] = dateTimeString.split(' ');
        const [year, month, day] = datePart.split('-');
        return `${day}.${month}.${year} ${timePart}`;
    }
}
